import React, {useRef, useState} from 'react'
import {TableComp} from 'sz-react-utils-lite'
import { Drawer, Card, Button, Tooltip, Tabs } from 'antd'
import {DisplayDate, DefaultTablePagination} from '../../../components/_utils/appUtils'
import {useDispatch} from 'react-redux'
import { countArticleByEmailFxn, getMemberHistory } from '../actions'
import ChangeHistory from '../drawers/changeHistory'
import ReactHtmlParser from 'react-html-parser'
import OnlineSubmissionComp from '../../searchResult/components/onlineSubmissionComp'
import ArticleHistoryTable from '../components/ArticleHistoryTable'

const { TabPane } = Tabs;

const AuthorHistory = (props) => {
  let {visible, onClose, articleId, ids, data} = props
  let [changeHistoryVisible, setChangeHistoryVisible] = useState(false)
  let [totalCount, setTotalCount] = useState()
  let [selectedEmail, setSelectedEmail] = useState()
  const dispatch = useDispatch()
  const apiRequest = (params) => {
    return new Promise(async (resolve) => {
      let obj = {
        email : props.emailId
      }
      let data = await dispatch(countArticleByEmailFxn(obj))
      setTotalCount(data.totalCount)
      setSelectedEmail(data.email)
      resolve({})
    })
  }

  // Trigger apiRequest on mount to get totalCount and selectedEmail for the drawer title
  React.useEffect(() => {
    if (props.emailId) {
      apiRequest()
    }
  }, [props.emailId])

  return (
    <Drawer
      title={`Article List - (Total : ${totalCount}) | Email : ${selectedEmail}`}
      width={'90%'}
      visible={visible}
      placement='right'
      onClose={onClose}>

      <Card>
        <Tabs defaultActiveKey="1">
          <TabPane tab="Article History" key="1">
            <ArticleHistoryTable emailId={props.emailId} />
          </TabPane>
          <TabPane tab="Online Submission" key="2">
            <OnlineSubmissionComp defaultSearchTerm={props.emailId} />
          </TabPane>
        </Tabs>
      </Card>


    </Drawer>
  )
}

export default AuthorHistory
